import { memo } from 'react';
import { styled } from '@mui/material/styles';
import Button from 'src/components/Button';

const StyledButton = styled(Button)({
  padding: ' 4px 8px',
  borderRadius: '10px',
  maxWidth: 'max-content',
  minWidth: '112px',
  height: '34px',
});

const Status = ({ onClick, children, disabled, ...rest }) => (
  <StyledButton variant="outlined" onClick={onClick} disabled={disabled} {...rest}>
    {children}
  </StyledButton>
);

export default memo(Status);
